import { Content } from './types'

const boxtext: Content = {
    type: 'boxtext',
    name: 'Kadertekst',
}

export default boxtext
